import React, { ReactElement, useEffect, useState } from 'react';
import { FormInputMobile, FormTextInput } from '../../../../../../shared/components/crmFormElement/FormInput';
import { GUTTOR_SPACE, VALIDATE_MESSAGES } from '../../../../../../shared/constants/commonConstants';
import { Button, Col, Form, Row } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { ApplicationDetailModel } from '../../../../../../store/models/applicationDetailModel';
import { RootState } from '../../../../../../store';
import {
  setHospitalSearchValues,
  setPatientSearchDetail,
  setHISCardSelected,
  getPatientVisitDetails,
  getPatientAllVisitsDetails,
  setIsHISClaim,
  setHospitalPatientSearchDetails,
} from '../../../../../../store/actions/hospitalAction';
import Panel from '../../../../../../shared/components/card/Panel';
import HISCard from '../cards/BeneficiaryCard/HISCard';
import { centeredNotification } from '../../../../../../utils/utility';
import { setAdmissionForm, setIsAbhaVerified, setIsShowAdmissionForm, setSelectedBeneficiary, setUploadedFiles } from '../../../../../../store/actions/newAdmissionAction';
import { cloneDeep } from 'lodash';
import { DEFAULT_ADMISSION_FORM_VALUE } from '../../../../../../shared/constants/crmConstants';
import useSetDefaultPayer from '../../../../../../shared/hooks/useSetDefaultPayer';
import { setSelectedPolicyDetail } from '../../../../../../store/actions/nhcxAction';

const HISSearch = (props: any): ReactElement | null => {
  const { selectedOption, form, resetHISForm } = props;
  const dispatch = useDispatch();
  const [baseForm] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [showFields, isShowFields] = useState<any>({});
  const appDetail = useSelector((state: RootState): ApplicationDetailModel => state.applicationDetail);
  const data = appDetail?._applicationDetail?.hospitalDetail?.providerConfigurableProperties?.integrationSystemFields;
  const hisFields = JSON.parse(data)?.HISFields;
  const [nextClicked, setNextClicked] = useState(false);
  const [disableSearch, setDisableSearch] = useState<boolean>(false);
  const {isVisitsEnabled, hisid, hisProviderID} = appDetail?._applicationDetail?.hospitalDetail?.providerConfigurableProperties;
  const [tempBeneficiary, setTempBeneficiary] = useState<any>(null);
  const [dataFound, setDataFound] = useState(true);
  const { hospitalSearchPatientDetails, hospitalSearchValues } = useSelector((state: RootState): any => state.hospital);
  const setDefaultPayer = useSetDefaultPayer();

  useEffect((): any => {
    fields();
  }, []);
  // Extracting "key," "type," and "placeholder" for each field
  const fields = (): any => {
    const extractedFields: any = {};
    for (const fieldName in hisFields) {
      if (hisFields.hasOwnProperty(fieldName)) {
        const fieldData = hisFields[fieldName];
        extractedFields[fieldName] = {
          key: fieldData?.key,
          type: fieldData?.type,
          placeholder: fieldData?.placeholder,
          label: fieldData?.label,
        };
      }
    }
    const dataForState = { ...extractedFields };
    isShowFields(dataForState);
  };
  const onClickSearch = (formVal: any): any => {
    const HISVisitsPayload = {
      ...(formVal?.maxID ? { uhid: formVal.maxID } : formVal),
      'loggedInUserId': appDetail?._applicationDetail?.userDetail?.userId,
      'hisMasterID': hisid,
      'hisProviderID': hisProviderID,
    };
    setLoading(true);
    if (isVisitsEnabled) {
      dispatch(getPatientAllVisitsDetails(HISVisitsPayload, onSuccess, onError));
    } else {
      const HISPatientPayload = {
        ...HISVisitsPayload,
        'visitCode': '0',
        'visitType': '',
      };
      dispatch(getPatientVisitDetails(HISPatientPayload, onSuccess, onError));
    }
    dispatch(setHospitalSearchValues(formVal));
    setTempBeneficiary(null);
    setNextClicked(false);
    form?.resetFields(['payer']);
    setDefaultPayer();
  };

  useEffect((): void => {
    baseForm.resetFields();
    form?.resetFields(['payer']);
    dispatch(setHospitalPatientSearchDetails([]));
    dispatch(setHISCardSelected(false));
    setDefaultPayer();
    initiateMemberForm();
  }, [selectedOption, resetHISForm]);

  const onSuccess = (): any => {
    setDataFound(true);
    setLoading(false);
    dispatch(setHISCardSelected(false));
  };

  const onError = (e: any): any => {
    centeredNotification(e);
    setLoading(false);
    setDataFound(false);
    dispatch(setHISCardSelected(true));     // flag set to true so that Policy search is showed
  };
  const validateFields = (): any => {
    setTimeout((): any => {
      baseForm
        ?.validateFields()
        .then((): any => {
          setDisableSearch(true);
        })
        .catch((error: any): any => {
          const { errorFields } = error;
          if (errorFields?.length > 0) {
            setDisableSearch(false);
          }
        });
    }, 200);
  };

  const initiateMemberForm = (): void => {
    dispatch(setIsShowAdmissionForm(false));
    dispatch(setSelectedBeneficiary(null));
    dispatch(setAdmissionForm(cloneDeep(DEFAULT_ADMISSION_FORM_VALUE)));
    dispatch(setUploadedFiles([]));
    dispatch(setIsAbhaVerified(false, {}));
  };

  const HISSearchUi = (): any => {
    validateFields();
    return <>
      {(showFields[selectedOption] && showFields[selectedOption]?.type !== 'Mobile') &&
        <Col span={24} style = {{paddingLeft: '0px'}}>
          <FormTextInput detail={{
            key: showFields[selectedOption] && showFields[selectedOption]?.key,
            placeholder: showFields[selectedOption]?.placeholder,
            size: 16,
            required: true,
            label: showFields[selectedOption]?.label,
          }} />
        </Col>
      }
      {showFields[selectedOption]?.type === 'Mobile' &&

        <Col span={24} style = {{paddingLeft: '0px'}}>
          <FormInputMobile detail={{
            key: showFields[selectedOption]?.key,
            placeholder: showFields[selectedOption]?.placeholder,
            size: 16,
            label: showFields[selectedOption]?.label,
            required: true,
          }} />
        </Col>
      }
    </>;
  };
  return (
    <><Panel title="HIS Search">
      <Form
        layout="vertical"
        form={baseForm}
        validateMessages={VALIDATE_MESSAGES}
        onFinish={onClickSearch}
        requiredMark="optional"
        onValuesChange={validateFields}
        noValidate={true}>
        <Row gutter={GUTTOR_SPACE}>
          {HISSearchUi()}
          <Col md={24} className="text-right">
            <Button
              data-testid="beneficiary-search-button"
              type={!disableSearch ? undefined : 'primary'}
              htmlType="submit"
              loading={loading}
              className={`his-next-button
                ${!disableSearch ? 'benef-submit-disabled' : 'benef-submit-btn'}
              `}
              disabled={!disableSearch}
            >Search</Button>
          </Col>
        </Row>
      </Form>
    </Panel>
      {!dataFound && !loading &&
        <Row className="benef-text">
          <p>No Data was found.</p>
        </Row>
      }

      <Row gutter={GUTTOR_SPACE}>
        {hospitalSearchPatientDetails?.map((beneficiary: any, index: number): ReactElement => {
          return (
            <>
              {!tempBeneficiary && (
                <Col md={24} key={index} onClick={(): void => setTempBeneficiary(beneficiary)}>
                  <HISCard
                    HISPatient={beneficiary}
                    index={index}
                    isSelected={beneficiary === tempBeneficiary}
                  />
                </Col>
              )}
              {tempBeneficiary === beneficiary && (
                <Col md={24} key={index}>
                  <HISCard
                    HISPatient={beneficiary}
                    index={index}
                    isSelected={beneficiary === tempBeneficiary}
                  />

                  <Col md={24} className = "his-button">
                    <Button className="his-previous-button"
                      onClick={(): any => {
                        // Unselect the patient detail and show all cards again
                        setTempBeneficiary(null);
                        setNextClicked(false);
                        dispatch(setHISCardSelected(false));
                        nextClicked && dispatch(setPatientSearchDetail([]));
                        dispatch(setSelectedPolicyDetail([]));
                        form?.resetFields(['payer']);
                        setDefaultPayer();
                      }}
                    >Previous</Button>
                    {!nextClicked && (<Button className="his-next-button"
                      onClick={(): any => {
                        // Proceed to the next step with the selected patient detail
                        setNextClicked(true);
                        dispatch(setHISCardSelected(true));
                        dispatch(setIsHISClaim(true));            // flag for mithril decide if HIS claim or not
                        if (isVisitsEnabled) {
                          const HISVisitsPayload = {
                            ...beneficiary,
                            ...hospitalSearchValues,
                            'loggedInUserId': appDetail?._applicationDetail?.userDetail?.userId,
                            'hisMasterID': hisid,
                            'hisProviderID': hisProviderID,
                          };
                          dispatch(getPatientVisitDetails(HISVisitsPayload, onSuccess, onError, isVisitsEnabled));
                        } else {
                          dispatch(setPatientSearchDetail(beneficiary));
                        }
                      }}
                    >Next</Button>
                  )}
                  </Col>
                </Col>
              )}
            </>
          );
        })}
      </Row>
    </>
  );
};
export default HISSearch;
